var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.894,
    height: 96.894,
    viewBox: "0 0 96.894 96.894",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "qr_code_FILL0_wght300_GRAD0_opsz24",
    d: "M140-777.252V-820h42.747v42.747Zm8.549-8.549H174.2V-811.45H148.55ZM140-723.1v-42.747h42.747V-723.1Zm8.549-8.549H174.2V-757.3H148.55Zm45.6-45.6V-820H236.9v42.747ZM202.7-785.8h25.649V-811.45H202.7Zm23.511,62.7v-10.687H236.9V-723.1Zm-32.061-32.061v-10.687h10.687v10.687Zm10.687,10.687v-10.687h10.687v10.687Zm-10.687,10.687v-10.687h10.687v10.687ZM204.835-723.1v-10.687h10.687V-723.1Zm10.687-10.687v-10.687h10.687v10.687Zm0-21.374v-10.687h10.687v10.687Zm10.687,10.687v-10.687H236.9v10.687Z",
    transform: "translate(-140.001 819.999)",
    fill: "#007CC4",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeIcon);
export default __webpack_public_path__ + "static/media/qr-code-icon.ad8dd7fcd0fd1c5f211daf4cc4a8fd30.svg";
export { ForwardRef as ReactComponent };